import { COMPANY_CONFIG } from '../../../constants/companyConfig';
import AddOnsAlternate from './addOnsAlternate';
import AddOnsDefault from './addOnsDefault';

const AddOnsNode = (props) => {
  const useAlternate = COMPANY_CONFIG.features?.customNodeHandling;
  return useAlternate ? <AddOnsAlternate {...props} /> : <AddOnsDefault {...props} />;
};

export default AddOnsNode;
